var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "提示文字" } },
        [
          _c("el-input", {
            attrs: { size: "small", placeholder: "提醒添加记录的提示" },
            model: {
              value: _vm.value.placeholder,
              callback: function ($$v) {
                _vm.$set(_vm.value, "placeholder", $$v)
              },
              expression: "value.placeholder",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "最大行数" } },
        [
          _c(
            "tip",
            {
              attrs: {
                slot: "label",
                content: "允许添加多少条记录（为0则不限制）",
              },
              slot: "label",
            },
            [_vm._v("最大行数")]
          ),
          _c("el-input-number", {
            attrs: {
              "controls-position": "right",
              precision: 0,
              max: 100,
              min: 0,
              size: "small",
              placeholder: "限制条数",
            },
            model: {
              value: _vm.value.maxSize,
              callback: function ($$v) {
                _vm.$set(_vm.value, "maxSize", $$v)
              },
              expression: "value.maxSize",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "布局方式" } },
        [
          _c(
            "el-radio",
            {
              attrs: { name: "layout", label: true },
              model: {
                value: _vm.value.rowLayout,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "rowLayout", $$v)
                },
                expression: "value.rowLayout",
              },
            },
            [_vm._v("按表格")]
          ),
          _c(
            "el-radio",
            {
              attrs: { name: "layout", label: false },
              model: {
                value: _vm.value.rowLayout,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "rowLayout", $$v)
                },
                expression: "value.rowLayout",
              },
            },
            [_vm._v("按表单")]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "展示合计" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.value.showSummary,
              callback: function ($$v) {
                _vm.$set(_vm.value, "showSummary", $$v)
              },
              expression: "value.showSummary",
            },
          }),
          _vm.value.showSummary
            ? _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    size: "small",
                    multiple: "",
                    clearable: "",
                    placeholder: "请选择合计项",
                  },
                  model: {
                    value: _vm.value.summaryColumns,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "summaryColumns", $$v)
                    },
                    expression: "value.summaryColumns",
                  },
                },
                _vm._l(_vm.columns, function (column) {
                  return _c("el-option", {
                    key: column.id,
                    attrs: { label: column.title, value: column.id },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "展示边框" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.value.showBorder,
              callback: function ($$v) {
                _vm.$set(_vm.value, "showBorder", $$v)
              },
              expression: "value.showBorder",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }